import Interface from '@components/ui/interface.vue';
import Fastbuy from '@components/ui/fastBuy.vue';
import Button from '@components/ui/button.vue';
import Slider from '@components/header-slider/script.js';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'Header',
  components: {
    'header-slider-cpm': Slider,
    Interface,
    Fastbuy,
    't-button': Button,
  },
  computed: {
    ...mapState('params', ['mobile']),
  },
  methods: {
    ...mapMutations('params', ['openleftMenu']),
  },
  mounted() {
    if (!this.mobile) {
      setTimeout(() => {
        var myWave = wavify(document.querySelector('#header-wave'), {
          height: 15,
          bones: 4,
          amplitude: 40,
          color: '#F5F7FA',
          speed: 0.13,
        });
      }, 100);
    }
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/header/script.js